export default __webpack_public_path__ + "99b0a7e0a290248b5ba08f3435ae5500.ttf";